
//////////////////////////////////////////////////////
// 🔧 공통 컴포넌트들
//////////////////////////////////////////////////////

import { Box, Typography } from "@mui/material";
 
export const SectionTitle = ({ title }) => (
  <Typography sx={{ mt: 3, mb: 1, color: "#60a5fa", fontWeight: "bold" }}>
    | {title}
  </Typography>
);

// export const SelectField = ({ name, label, register }) => (
//   <TextField select fullWidth label={label} {...register(name)} sx={inputStyle}>
//     <MenuItem value="">선택</MenuItem>
//     <MenuItem value="A">옵션 A</MenuItem>
//     <MenuItem value="B">옵션 B</MenuItem>
//   </TextField>
// );

//////////////////////////////////////////////////////
// 🔧 레이아웃 스타일
//////////////////////////////////////////////////////

export const Grid2 = ({ children }) => (
  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>{children}</Box>
);

export const Grid4 = ({ children }) => (
  <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 1 }}>
    {children}
  </Box>
);

export const boxStyle = {
  p: 2,
  border: "1px solid #1e293b",
  borderRadius: 2,
  mb: 2,
  backgroundColor: "#181e28"
};

export const inputStyle = {
  mb: 2,
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#0f172a",
    color: "#e2e8f0"
  },
  "& .MuiInputLabel-root": {
    color: "#94a3b8"
  }
};